import { inject, Injectable } from '@angular/core';
import { findChapterIndexByIdRef } from '../../../helpers/locator';
import { MetadataService } from '../../metadata/metadata';

@Injectable({
  providedIn: 'root',
})
export class ChapterService {
  private readonly metadataService = inject(MetadataService);
  private readonly metadata = this.metadataService.metadata;

  getTitleFromHref(href?: string): string {
    if (!href) return '';
    return this.getTitleFromTOC(href) ?? '';
  }

  private getTitleFromTOC(href: string): string | null {
    if (!this.metadata()?.readium2.manifest.toc) return null;

    const { toc } = this.metadata()!.readium2.manifest;
    const tocItem = toc?.findWithHref(href);
    if (tocItem) return tocItem.title ?? null;

    const positions = this.metadataService.positions();
    const positionIndex = positions.findIndex((p) => p.href === href);
    if (positionIndex === -1) return null;
    const lastToc = positions
      .slice(0, positionIndex + 1)
      .map((p) => toc?.findWithHref(p.href))
      .findLast((t) => Boolean(t));
    const title = lastToc?.title ?? null;
    return title;
  }

  findHrefByIdRef(idRef: string): string | undefined {
    const hrefList = this.metadataService.positions().map((p) => p.href);
    const hrefIndex = findChapterIndexByIdRef(
      hrefList,
      idRef,
      this.metadataService.componentNames(),
    );
    return hrefList[hrefIndex];
  }
}
